import { Paths } from "components/common/navigation";
import { actions } from "components/login/logic/actions";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.props.logout();
    }
    render() {
        return <Navigate to={Paths.LOGIN} />;
    }
}

Logout.propTypes = {
    logout: PropTypes.func.isRequired,
};

export default connect(null, (dispatch) => ({
    logout: () => dispatch(actions.LOGOUT.send()),
}))(Logout);
